import React, { ErrorInfo } from 'react';
import { Snackbar } from '@dls/react-core';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class GlobalErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    return (
      <>
        <Snackbar
          open={this.state.hasError}
          autoHideDuration={6000 * 100}
          onClose={() => {}}
          message={this.state.error?.message}
        />
        {this.props.children}
      </>
    );
  }
}
